import React from "react";
import {
  Addon,
  EntityType,
} from "../../../../api/grpc/subscription/subscription";
import { getAddonsName } from "../../lib/getAddonsName";

interface Props {
  data?: Addon[];
  showQuantity?: boolean;
  hasUnlimitedUsers?: boolean;
}

export const SubscriptionItemsCount = ({
  data,
  showQuantity = true,
  hasUnlimitedUsers = false,
}: Props) => {
  return (
    <>
      {data &&
        data.map((item) => (
          <div
            key={`${item.entityType}-${item.id}`}
            className="SubscriptionItemsCount"
          >
            <span>
              {getAddonsName(
                item.name.toLocaleLowerCase(),
                item.quantity,
                item.entityType
              )}
            </span>
            {showQuantity && (
              <span>
                {hasUnlimitedUsers && item.entityType === EntityType.USER
                  ? "Unlimited"
                  : `${item.quantity}x`}
              </span>
            )}
          </div>
        ))}
    </>
  );
};
